import { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { GOOGLE, MAP, MapContext } from './constants';

export function Polygon({
	paths,
	fillColor,
	fillOpacity,
	strokeColor,
	strokeOpacity,
	strokeWeight,
	visible,
}) {
	const mapContext = useContext(MapContext);
	const map = mapContext[MAP];
	const google = mapContext[GOOGLE];
	const [polygon, setPolygon] = useState(null);

	useEffect(() => {
		if (google && map && !polygon) {
			const newPoly = new google.maps.Polygon({
				map,
				paths,
				strokeColor,
				strokeOpacity,
				strokeWeight,
				fillColor,
				fillOpacity,
				visible
			});

			setPolygon(newPoly);
		}
	}, [google, map]); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		if (polygon) {
			polygon.setVisible(visible);
		}
	}, [visible, polygon]);

	useEffect(() => {
		return () => {
			if (polygon) {
				polygon.setMap(null);
			}
		};
	}, [polygon]);

	return null;
}

Polygon.propTypes = {
	paths: PropTypes.arrayOf(
		PropTypes.oneOfType([
			PropTypes.array,
			PropTypes.object
		])
	).isRequired,
	fillColor: PropTypes.string,
	fillOpacity: PropTypes.number,
	strokeColor: PropTypes.string,
	strokeOpacity: PropTypes.number,
	strokeWeight: PropTypes.number,
	visible: PropTypes.bool
};

export default Polygon;
